import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["iframe", "container"];

  hide() {
    this.iframeTarget.src = "";
    this.element.classList.add("hidden");
    document.body.style.overflow = "";
  }

  iframeLoaded() {
  }

  cancel() {
    this.hide();
  }
}
